import React from "react";
import PropTypes from "prop-types";
import { Alert } from "@mui/material";
import ContractTable from "../../contracts/ContractTable";
import { useGetContractsQuery } from "../../../../features/contracts/contractsApiSlice";
import useAuth from "../../../../hooks/useAuth";

function SelectContractStep({ onSubmit }) {
  const { isAdmin, isSuperAdmin } = useAuth();
  const { data: contracts } = useGetContractsQuery(undefined, {
    skip: !(isAdmin || isSuperAdmin),
  });

  return (
    <div>
      {isAdmin || isSuperAdmin ? (
        contracts && (
          <ContractTable onSubmit={onSubmit} contracts={contracts} />
        )
      ) : (
        <Alert severity="warning">
          Nur Admins können Verträge auswählen.
        </Alert>
      )}
    </div>
  );
}

SelectContractStep.propTypes = {
  onSubmit: PropTypes.func,
};

export default SelectContractStep;
